// Sổ tiền giữ lại: cộng dồn PCTN giữ lại (PCTN_GL) và tiền giữ lại theo khối lượng (KL_GL) từ số đã
// chốt của các kỳ đã duyệt. Chỉ ghi nhận: chưa có phần trả lại, nên số đang giữ = tổng đã giữ.
// Không lưu riêng ở bảng nào: kỳ được mở lại thì số của kỳ đó rời sổ đến khi duyệt lại, như báo cáo.

export const RETENTION_PARTS = [
    { key: 'pctn', code: 'PCTN_GL', label: 'PCTN giữ lại' },
    { key: 'weight', code: 'KL_GL', label: 'Giữ lại theo KL' },
];

const NO_TEAM = 'Chưa có tổ';
const WORK_STATUS_LEFT = 'Đã nghỉ';
const amountOf = (values, code) => Math.round(Number(values?.[code]) || 0);
const periodSortKey = (entry) => entry.nam * 100 + entry.thang;

/** Mỗi dòng lương của kỳ đã duyệt có giữ lại thành một dòng sổ; dòng không giữ gì bị bỏ. */
export function buildRetentionEntries(periods, details) {
    const periodByCode = new Map(periods.filter((period) => period.TRANG_THAI === 'DA_DUYET').map((period) => [period.MA_KY, period]));
    return details.flatMap((detail) => {
        const period = periodByCode.get(detail.BANG_ID);
        if (!period) return [];
        const values = detail.GIA_TRI_TINH?.v ?? {};
        const parts = Object.fromEntries(RETENTION_PARTS.map(({ key, code }) => [key, amountOf(values, code)]));
        const total = RETENTION_PARTS.reduce((sum, { key }) => sum + parts[key], 0);
        if (!total) return [];
        return [{
            id: detail.ID,
            maKy: period.MA_KY,
            thang: period.THANG,
            nam: period.NAM,
            soHd: detail.NHAN_SU_ID,
            hoTen: detail.HO_TEN_SNAPSHOT || detail.NHAN_SU_ID,
            to: detail.TO_SNAPSHOT || NO_TEAM,
            ...parts,
            total,
        }];
    });
}

/**
 * Gom sổ theo người. Tên và tổ lấy theo kỳ gần nhất; người "Đã nghỉ" trong Nhân sự được đánh dấu để
 * kế toán biết còn tiền giữ lại phải xử lý.
 */
export function buildRetentionLedger(entries, employees = []) {
    const employeeBySoHd = new Map(employees.map((employee) => [String(employee.SO_HD), employee]));
    const people = new Map();
    for (const entry of [...entries].sort((left, right) => periodSortKey(left) - periodSortKey(right))) {
        const person = people.get(entry.soHd) ?? { soHd: entry.soHd, entries: [], pctn: 0, weight: 0, total: 0 };
        person.entries.push(entry);
        person.hoTen = entry.hoTen;
        person.to = entry.to;
        for (const { key } of RETENTION_PARTS) person[key] += entry[key];
        person.total += entry.total;
        people.set(entry.soHd, person);
    }
    return Array.from(people.values()).map((person) => {
        const employee = employeeBySoHd.get(String(person.soHd));
        const last = person.entries[person.entries.length - 1];
        return {
            ...person,
            hoTen: employee?.HO_TEN || person.hoTen,
            periodCount: person.entries.length,
            lastPeriod: `${String(last.thang).padStart(2, '0')}/${last.nam}`,
            left: employee?.TRANG_THAI_LAM_VIEC === WORK_STATUS_LEFT,
            leftOn: employee?.NGAY_NGHI ?? null,
            entries: [...person.entries].reverse(),
        };
    });
}

export function summarizeRetention(rows) {
    return {
        people: rows.length,
        pctn: rows.reduce((sum, row) => sum + row.pctn, 0),
        weight: rows.reduce((sum, row) => sum + row.weight, 0),
        total: rows.reduce((sum, row) => sum + row.total, 0),
        leftCount: rows.filter((row) => row.left).length,
    };
}
